import { ReactNode, useEffect } from 'react';
import { useAppDispatch } from '@/app/stores/store';
import { store } from '@/app/stores/store';
import { setUser, setSessionResolved } from '@/app/stores/slices/authSlice';
import api from '@/lib/api-client';

export interface AuthSessionUser {
  id: string;
  email: string;
  name: string;
  role: 'ADMIN' | 'CASHIER';
  scopeUserId: string;
}

/** Loads session from httpOnly cookies via GET /auth/me once on app mount. */
export function AuthSessionBootstrap({ children }: { children: ReactNode }) {
  const dispatch = useAppDispatch();

  useEffect(() => {
    let cancelled = false;

    localStorage.removeItem('auth_token');
    localStorage.removeItem('refresh_token');
    localStorage.removeItem('auth_user');

    (async () => {
      try {
        const r = await api.get<AuthSessionUser>('/auth/me');
        if (!cancelled) dispatch(setUser(r.data));
      } catch {
        if (!cancelled && !store.getState().auth.user) {
          dispatch(setUser(null));
        }
      } finally {
        if (!cancelled) dispatch(setSessionResolved(true));
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [dispatch]);

  return <>{children}</>;
}
